import { SpaceTypeEnum } from 'src/common/external/bambi-api/bambiApi';

export const spaceTypes: SpaceTypeEnum[] = [
  'wheelchair',
  'stretcher',
  'ambulatory',
  'wheelchair xl',
  'broda chair',
  'geri chair',
];
